<template>
  <v-menu
    content-class="context_menu white rounded-lg"
    v-model="showMenu"
    :position-x="x"
    :position-y="y"
    absolute
    offset-y
  >
    <template v-if="!contextLoad">
      <template v-for="(item, index) in items">
        <ChatContextMenuItem :item="item" :key="index" />
      </template>
    </template>
  </v-menu>
</template>

<script>
import ChatContextMenuItem from 'components/chat/contextMenu/ChatContextMenuItem'
export default {
  name: 'ChatContextMenu',
  components: {
    ChatContextMenuItem,
  },
  props: {
    items: Array,
    value: [String, Number, Function, Array, Object, Boolean],
  },

  data() {
    return {
      showMenu: false,
      x: 0,
      y: 0,
      targetObj: null,
      contextLoad: false,
    }
  },
  watch: {
    showMenu() {
      this.$emit('showMenu', this.showMenu)
    },
  },
  methods: {
    onContext({ contextmenu, targetObj }) {
      // console.log('ChatContextMenu onContext', { contextmenu, targetObj })
      contextmenu.preventDefault()
      this.targetObj = null
      this.showMenu = false
      this.contextLoad = true
      this.x = contextmenu.clientX
      this.y = contextmenu.clientY
      this.targetObj = targetObj
      this.$set(this.targetObj, 'target', contextmenu.target)
      this.updateInput()
      this.$nextTick(() => {
        this.contextLoad = false
        if (this.items && this.items.find((i) => i.if)) {
          this.showMenu = true
        }
      })
    },
    updateInput() {
      this.$emit('input', this.targetObj)
    },
  },
}
</script>

<style lang="scss" scoped>
.context_menu {
  box-shadow: 0px rgba(239, 239, 239, 0.25);
}
</style>
